import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import { setTitle } from 'utils/head';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import { Button, DataGrid, LoadingWrapper } from 'components/custom';
import { AddCircle, Delete, Edit } from '@mui/icons-material';
import { useSchoolsQueryApi } from 'api/school-management';
import SchoolManagementEditDialog from './SchoolManagementEditDialog';
import SchoolManagementDeleteDialog from './SchoolManagementDeleteDialog';
const SchoolManagement = () => {
    const { t } = useTranslation('schoolManagement');
    const schoolsStatus = useSchoolsQueryApi();
    const [schoolToDelete, setSchoolToDelete] = React.useState(null);
    const [schoolToEdit, setSchoolToEdit] = React.useState(null);
    const columns = [
        {
            field: 'name',
            headerName: t('columns.name'),
            minWidth: 200,
            sortable: false,
        },
        {
            field: 'status',
            headerName: t('columns.status'),
            renderCell: (params) => t(`SchoolManagementEditDialog.statusField.options.${params.row.status}`),
            sortable: false,
        },
        {
            align: 'center',
            field: 'seats',
            headerName: t('columns.seats'),
            renderCell: (params) => `${params.row.seatsUsed} / ${params.row.seats}`,
            sortable: false,
        },
        {
            align: 'center',
            field: 'storageSizeBytes',
            headerName: t('columns.storageSize'),
            sortable: false,
            width: 160,
        },
        {
            field: 'schoolIdentifier',
            headerName: t('columns.schoolIdentifier'),
            renderCell: (params) => params.row.schoolIdentifier?.length ? params.row.schoolIdentifier : '–',
            sortable: false,
        },
        {
            field: 'domains',
            flex: 1,
            headerName: t('columns.domains'),
            renderCell: (params) => params.row.domains.length ? params.row.domains.join(', ') : '–',
            sortable: false,
        },
        {
            field: 'actions',
            headerName: '',
            renderCell: (params) => (_jsxs(Box, { children: [_jsx(IconButton, { color: "secondary", disabled: params.row.status === 'CANCELED', onClick: () => {
                            setSchoolToEdit(params.row);
                        }, title: t('editSchoolButton'), children: _jsx(Edit, {}) }), _jsx(IconButton, { color: "error", disabled: params.row.status === 'CANCELED', onClick: () => {
                            setSchoolToDelete(params.row);
                        }, title: t('deleteSchoolButton'), children: _jsx(Delete, {}) })] })),
            sortable: false,
        },
    ];
    useEffect(() => {
        setTitle(t('title'));
    }, [t]);
    return (_jsxs(Stack, { spacing: 2, children: [_jsx(Typography, { color: "secondary", fontWeight: "bold", variant: "h6", children: t('title') }), _jsxs(LoadingWrapper, { status: schoolsStatus, children: [_jsx(DataGrid, { autoHeight: true, hideFooter: true, columns: columns, rows: schoolsStatus.data?.schools ?? [], sx: {
                            '& .MuiDataGrid-row:nth-of-type(odd)': {
                                '&:hover': {
                                    backgroundColor: (theme) => theme.palette.action.hover,
                                },
                                backgroundColor: (theme) => theme.palette.inactive.main,
                            },
                            border: 'none',
                            fontSize: '0.9rem',
                        } }), _jsx(Button, { color: "secondary", onClick: () => {
                            setSchoolToEdit({});
                        }, startIcon: _jsx(AddCircle, {}), sx: { alignSelf: 'end' }, children: t('addSchoolButton') }), _jsx(SchoolManagementEditDialog, { close: () => {
                            setSchoolToEdit(null);
                        }, schoolToEdit: schoolToEdit }), _jsx(SchoolManagementDeleteDialog, { close: () => {
                            setSchoolToDelete(null);
                        }, schoolToDelete: schoolToDelete })] })] }));
};
export default SchoolManagement;
